export const TASK_CONSTANTS = {
  // Pagination
  INITIAL_TASKS_PER_SECTION: 10,
  MAX_SECTIONS_PER_PAGE: 100,

  // Special identifiers
  UNASSIGNED_SECTION_KEY: -1,
  TEMP_ID_PREFIX: -1, // Multiplied by Date.now() for temp IDs

  // Sort orders
  PRIORITY_ORDER: {
    low: 1,
    medium: 2,
    high: 3,
    urgent: 4,
  } as const,

  STATUS_ORDER: { pending: 1, in_progress: 2, completed: 3, overdue: 4 } as const,
  TYPE_ORDER: { task: 1, medication: 2, appointment: 3, incident: 4, accident: 5 } as const,

  // Default values
  DEFAULT_STATUS: "pending" as const,
  DEFAULT_PRIORITY: "medium" as const,
  DEFAULT_SORT_FIELD: "created_at",
  DEFAULT_SORT_DIRECTION: "desc" as const,
} as const;

export type TaskStatus = keyof typeof TASK_CONSTANTS.STATUS_ORDER;
export type TaskPriority = keyof typeof TASK_CONSTANTS.PRIORITY_ORDER;
export type TaskType = keyof typeof TASK_CONSTANTS.TYPE_ORDER;

export const TASK_TYPE_OPTIONS = [
  {
    label: "Task",
    value: "task",
    color: "yellow",
    bgColor: "yellow-100",
    textColor: "neutral-700",
    icon: "material-symbols:task-alt",
  },
  {
    label: "Medication",
    value: "medication",
    color: "gray",
    bgColor: "emerald-100",
    textColor: "neutral-700",
    icon: "mdi:pill",
  },
  {
    label: "Appointment",
    value: "appointment",
    color: "violet",
    bgColor: "purple-100",
    textColor: "neutral-700",
    icon: "mdi:calendar-clock",
  },
  {
    label: "Incident",
    value: "incident",
    color: "red",
    bgColor: "red-100",
    textColor: "neutral-700",
    icon: "mdi:alert-circle",
  },
  {
    label: "Accident",
    value: "accident",
    color: "green",
    bgColor: "green-100",
    textColor: "neutral-700",
    icon: "mdi:ambulance",
  },
] as const;
